<template>
  <el-dialog
    title="导入出厂信息"
    :visible="visible"
    width="600px"
    top="5vh"
    :close-on-click-modal="false"
    @close="onClose">
    <div class="clearfix mar-b-md">
      <div class="box-inline pull-left mar-x-md text-center">
        <i class="fas fa-cloud-download-alt"></i>
      </div>
      <div class="box-inline pull-left">
        <div>
          下载模板
          <div class="text-muted">为提高导入的成功率，请下载并使用系统提供的模板</div>
        </div>
        <div class="mar-t-sm">
          <el-button type="primary" @click="downloadReport" :disabled="disDownloadBtn">
            <i class="fas fa-fw fa-download"></i> 下载模板
          </el-button>
        </div>
      </div>
    </div>
    <div class="clearfix">
      <div class="box-inline pull-left mar-x-md text-center">
        <i class="fas fa-cloud-upload-alt"></i>
      </div>
      <div class="box-inline pull-left">
        <div>
          上传文件
          <div class="text-muted">仅支持.xlsx,文件大小≤4M</div>
        </div>
        <div class="mar-t-sm clearfix">
          <el-input v-model="fileName" class="pull-left" style="width: 350px;"/>
          <el-button type="primary" @click="onFileClick" class="pull-left">选择文件</el-button>
          <div style="display: none;">
            <input ref="file" name="upfile" type="file" @change="changeFile" accept=".xlsx" />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
      <el-button type="primary" @click="onSubmit"
        :disabled="submitting || !fileName">
        <i class="far fa-save"></i> 开始导入
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      submitting: false,
      fileData: '',
      disDownloadBtn: false,
      fileName: '',
    };
  },
  props: {
    visible: Boolean,
  },
  computed: {
    ...mapState({
      token: state => state.Auth.token,
    }),
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.fileName = '';
      this.disDownloadBtn = false;
      this.submitting = false;
    },
    onFileClick() {
      this.$refs.file.click();
    },
    changeFile() {
      const reads = new FileReader();
      if (this.$refs.file.files[0]) {
        this.fileData = this.$refs.file.files[0];
        reads.readAsDataURL(this.fileData);
        this.fileName = this.fileData.name;
      }
    },
    onSubmit() {
      this.submitting = true;
      const formData = new window.FormData();
      formData.append('file', this.fileData);
      if (this.beforeAvatarUpload()) {
        this.$axios.post('data/upload', formData).then(() => {
          this.$message({
            message: '导入成功!',
            type: 'success',
          });
          this.onClose();
          this.$emit('success-import');
        }).catch(({ response }) => {
          if (response.status === 400) {
            this.$message({
              message: response.data,
              type: 'warning',
            });
            return;
          }
          this.$sys.alarmResponse(response);
        }).finally(() => {
          this.submitting = false;
        });
      }
    },
    // 文件上传之前判断文件大小
    beforeAvatarUpload() {
      const isLt4M = this.fileData.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        this.$message({
          message: '上传模板大小不能超过4MB!',
          type: 'warning',
        });
        return false;
      }
      return true;
    },
    // 下载模版
    downloadReport() {
      if (typeof window.URL === 'undefined') {
        this.$message.error('您的浏览器不支持模板下载，请使用更先进的浏览器使用该功能！');
        return;
      }
      this.disDownloadBtn = true;
      this.$axios.get('download', { responseType: 'blob' }).then((response) => {
        this.autoDownloadBlobFile(
          new window.Blob([response.data], { type: 'data:text/csv;charset=utf-8' }),
          '空白数据模板.xlsx'
        );
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.disDownloadBtn = false;
      });
    },
  },
};
</script>
